var _g, _rect, _g2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 93,
    viewBox: "0 0 85 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_55_1183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "url(#paint0_linear_55_1183)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint1_linear_55_1183)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_55_1183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.6416,
    y: 9.14197,
    width: 59.7531,
    height: 59.7531,
    rx: 29.8765,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.444 22.5988L48.3286 26.5257C49.0789 29.8565 51.6801 32.4577 55.0109 33.208L58.9378 34.0926L55.0109 34.9772C51.6801 35.7275 49.0789 38.3286 48.3286 41.6595L47.444 45.5864L46.5594 41.6595C45.8091 38.3286 43.208 35.7275 39.8771 34.9772L35.9502 34.0926L39.8771 33.208C43.208 32.4577 45.8091 29.8565 46.5594 26.5257L47.444 22.5988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.444 22.5988L48.3286 26.5257C49.0789 29.8565 51.6801 32.4577 55.0109 33.208L58.9378 34.0926L55.0109 34.9772C51.6801 35.7275 49.0789 38.3286 48.3286 41.6595L47.444 45.5864L46.5594 41.6595C45.8091 38.3286 43.208 35.7275 39.8771 34.9772L35.9502 34.0926L39.8771 33.208C43.208 32.4577 45.8091 29.8565 46.5594 26.5257L47.444 22.5988Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3085 39.0186L34.9404 41.8235C35.4763 44.2027 37.3343 46.0606 39.7134 46.5966L42.5184 47.2284L39.7134 47.8603C37.3343 48.3962 35.4763 50.2542 34.9404 52.6334L34.3085 55.4383L33.6767 52.6334C33.1407 50.2542 31.2828 48.3962 28.9036 47.8603L26.0986 47.2284L28.9036 46.5966C31.2828 46.0606 33.1407 44.2027 33.6767 41.8235L34.3085 39.0186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_55_1183",
    x: 0,
    y: 8,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_55_1183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_55_1183",
    x: 4.1416,
    y: 0.641968,
    width: 76.7529,
    height: 76.7531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_55_1183"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_1183",
    x1: 19.6484,
    y1: 28,
    x2: 64.6484,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#216AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B949B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FB7901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_1183",
    x1: 10,
    y1: 7,
    x2: 74,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#216AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B949B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FB7901"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e580f72cd38c68f5a5057272754587fb.svg";
export { ForwardRef as ReactComponent };